export const UI_TO_ACTION_MAP = {
  power: ["powerOff", "powerOn"],
  input: ["inputSource"],
  wake: [],
  sleep: [],
  hdmi_1: ["inputSource"],
  hdmi_2: ["inputSource"],
  hdmi_3: ["inputSource"],
  hdmi_4: ["inputSource"],
  settings: ["menu"],
  vol_up: ["volumeUp"],
  vol_down: ["volumeDown"],
  mute: ["mute"],
  nav_up: ["up"],
  nav_down: ["down"],
  nav_left: ["left"],
  nav_right: ["right"],
  ok: ["enter"],
  chan_up: ["channelUp"],
  chan_down: ["channelDown"],
  last: ["channelNext"],
  back: ["back"],
  home: ["home"],
  menu: ["menu"],
  info: ["info"],
  rew: ["seekBack"],
  play_pause: ["play", "pause"],
  ff: ["seekForward"],
  stop: ["stop"],
  num_1: ["digit1"],
  num_2: ["digit2"],
  num_3: ["digit3"],
  num_4: ["digit4"],
  num_5: ["digit5"],
  num_6: ["digit6"],
  num_7: ["digit7"],
  num_8: ["digit8"],
  num_9: ["digit9"],
  dash: [],
  num_0: ["digit0"],
  enter: ["enter"],
  color_red: [],
  color_green: [],
  color_yellow: [],
  color_blue: [],
};

export const APP_ACTION_MAP = {
  power: "power",
  input: "open_input_selector",
  settings: "settings",
  vol_up: "volume_up",
  vol_down: "volume_down",
  mute: "mute",
  nav_up: "up",
  nav_down: "down",
  nav_left: "left",
  nav_right: "right",
  ok: "enter",
  chan_up: "channel_up",
  chan_down: "channel_down",
  last: "last",
  back: "back",
  home: "home",
  menu: "menu",
  info: "info",
  rew: "rewind",
  play_pause: "play_pause",
  ff: "fast_forward",
  stop: "stop",
  num_1: "num_1",
  num_2: "num_2",
  num_3: "num_3",
  num_4: "num_4",
  num_5: "num_5",
  num_6: "num_6",
  num_7: "num_7",
  num_8: "num_8",
  num_9: "num_9",
  num_0: "num_0",
  enter: "enter",
};

export const WEBOS_ACTION_MAP = {
  nav_up: "dpad_up",
  nav_down: "dpad_down",
  nav_left: "dpad_left",
  nav_right: "dpad_right",
  ok: "select",
  back: "back",
  home: "home",
  menu: "menu",
  info: "info",
  vol_up: "volume_up",
  vol_down: "volume_down",
  mute: "mute_toggle",
  rew: "rewind",
  ff: "fast_forward",
  stop: "stop",
  chan_up: "channel_up",
  chan_down: "channel_down",
  last: "channel_last",
  input: "input",
  settings: "settings",
  power: "power_off",
  enter: "enter",
  dash: "dash",
  num_0: 'num_0',
  num_1: 'num_1',
  num_2: 'num_2',
  num_3: 'num_3',
  num_4: 'num_4',
  num_5: 'num_5',
  num_6: 'num_6',
  num_7: 'num_7',
  num_8: 'num_8',
  num_9: 'num_9',

  color_red: "color_red",
  color_green: "color_green",
  color_yellow: "color_yellow",
  color_blue: "color_blue",
};

// Typed Android key events supported by the embedded relay. Device firmware
// support is still a field observation, not implied by this mapping.
export const ADB_REMOTE_ACTION_MAP = {
  power: 'KEYCODE_POWER', input: 'KEYCODE_TV_INPUT', settings: 'KEYCODE_SETTINGS',
  vol_up: 'KEYCODE_VOLUME_UP', vol_down: 'KEYCODE_VOLUME_DOWN', mute: 'KEYCODE_VOLUME_MUTE',
  nav_up: 'KEYCODE_DPAD_UP', nav_down: 'KEYCODE_DPAD_DOWN',
  nav_left: 'KEYCODE_DPAD_LEFT', nav_right: 'KEYCODE_DPAD_RIGHT',
  ok: 'KEYCODE_DPAD_CENTER', back: 'KEYCODE_BACK', home: 'KEYCODE_HOME',
  chan_up: 'KEYCODE_CHANNEL_UP', chan_down: 'KEYCODE_CHANNEL_DOWN', last: 'KEYCODE_LAST_CHANNEL',
  menu: 'KEYCODE_MENU', info: 'KEYCODE_INFO',
  rew: 'KEYCODE_MEDIA_REWIND', play_pause: 'KEYCODE_MEDIA_PLAY_PAUSE',
  ff: 'KEYCODE_MEDIA_FAST_FORWARD', stop: 'KEYCODE_MEDIA_STOP',
  num_0: 'KEYCODE_0', num_1: 'KEYCODE_1', num_2: 'KEYCODE_2', num_3: 'KEYCODE_3',
  num_4: 'KEYCODE_4', num_5: 'KEYCODE_5', num_6: 'KEYCODE_6', num_7: 'KEYCODE_7',
  num_8: 'KEYCODE_8', num_9: 'KEYCODE_9', enter: 'KEYCODE_ENTER',
  color_red: 'KEYCODE_PROG_RED', color_green: 'KEYCODE_PROG_GREEN',
  color_yellow: 'KEYCODE_PROG_YELLOW', color_blue: 'KEYCODE_PROG_BLUE',
  wake: 'KEYCODE_WAKEUP', sleep: 'KEYCODE_SLEEP',
};

export const ANDROID_TV_REMOTE_ACTION_MAP = {
  power: "power",
  input: "input",
  tv_home: "input_tv_home",
  hdmi_1: "input_hdmi_1",
  hdmi_2: "input_hdmi_2",
  hdmi_3: "input_hdmi_3",
  hdmi_4: "input_hdmi_4",
  settings: "settings",
  vol_up: "volume_up",
  vol_down: "volume_down",
  mute: "mute",
  nav_up: "up",
  nav_down: "down",
  nav_left: "left",
  nav_right: "right",
  ok: "enter",
  chan_up: "channel_up",
  chan_down: "channel_down",
  last: "last",
  back: "back",
  home: "home",
  menu: "menu",
  info: "info",
  rew: "rewind",
  play_pause: "play_pause",
  ff: "fast_forward",
  stop: "stop",
  num_1: "num_1",
  num_2: "num_2",
  num_3: "num_3",
  num_4: "num_4",
  num_5: "num_5",
  num_6: "num_6",
  num_7: "num_7",
  num_8: "num_8",
  num_9: "num_9",
  num_0: "num_0",
  enter: "enter",
};

const METHOD_ACTION_KEYS = {
  android_tv_remote: [
    "home",
    "back",
    "menu",
    "up",
    "down",
    "left",
    "right",
    "enter",
    "volumeUp",
    "volumeDown",
    "mute",
    "powerOff",
    "play",
    "pause",
    "stop",
    "seekBack",
    "seekForward",
    "inputSource",
    "channelNext",
    "channelUp",
    "channelDown",
    "digit0",
    "digit1",
    "digit2",
    "digit3",
    "digit4",
    "digit5",
    "digit6",
    "digit7",
    "digit8",
    "digit9",
  ],
  app: [
    "home",
    "back",
    "menu",
    "up",
    "down",
    "left",
    "right",
    "enter",
    "volumeUp",
    "volumeDown",
    "mute",
    "play",
    "pause",
    "stop",
    "seekBack",
    "seekForward",
    "inputSource",
    'channelUp',
    'channelDown',
    "digit0",
    "digit1",
    "digit2",
    "digit3",
    "digit4",
    "digit5",
    "digit6",
    "digit7",
    "digit8",
    "digit9",
  ],
  assistant: [
    "home",
    "back",
    "up",
    "down",
    "left",
    "right",
    "enter",
    "volumeUp",
    "volumeDown",
    "mute",
    "unmute",
    "powerOn",
    "setVolume",
    "powerOff",
    "play",
    "pause",
    "stop",
    "seekBack",
    "seekForward",
    "inputSource",
    "switchToHDMI1",
    "switchToHDMI2",
    "switchToHDMI3",
    "switchToHDMI4",
    "switchToHDMI5",
    "switchToHDMI6",
    "switchToHDMI7",
    "switchToHDMI8",
    "channelNext",
    "channelUp",
    "channelDown",
  ],
  adb: [
    "home",
    "back",
    "menu",
    "up",
    "down",
    "left",
    "right",
    "enter",
    "volumeUp",
    "volumeDown",
    "mute",
    "powerOn",
    "powerOff",
    "rebootDevice",
    "launchApp",
    "forceStopApp",
    "play",
    "pause",
    "stop",
    "inputSource",
    "switchToHDMI1",
    "switchToHDMI2",
    "switchToHDMI3",
    "switchToHDMI4",
    "switchToHDMI5",
    "switchToHDMI6",
    "switchToHDMI7",
    "switchToHDMI8",
    "channelNext",
    "channelUp",
    "channelDown",
    "digit0",
    "digit1",
    "digit2",
    "digit3",
    "digit4",
    "digit5",
    "digit6",
    "digit7",
    "digit8",
    "digit9",
  ],
  bluetooth: [
    "home",
    "back",
    "up",
    "down",
    "left",
    "right",
    "enter",
    "volumeUp",
    "volumeDown",
    "mute",
    "rebootDevice",
    "launchApp",
    "forceStopApp",
    "play",
    "pause",
    "stop",
    "seekBack",
    "seekForward",
    "digit0",
    "digit1",
    "digit2",
    "digit3",
    "digit4",
    "digit5",
    "digit6",
    "digit7",
    "digit8",
    "digit9",
  ],
  cec: [
    "home",
    "back",
    "menu",
    "up",
    "down",
    "left",
    "right",
    "enter",
    "volumeUp",
    "volumeDown",
    "mute",
    "powerOn",
    "powerOff",
    "play",
    "pause",
    "stop",
    "inputSource",
    "switchToHDMI1",
    "switchToHDMI2",
    "switchToHDMI3",
    "switchToHDMI4",
    "switchToHDMI5",
    "switchToHDMI6",
    "switchToHDMI7",
    "switchToHDMI8",
    "channelNext",
    "channelUp",
    "channelDown",
  ],
  cast: [
    "volumeUp",
    "volumeDown",
    "mute",
    "unmute",
    "play",
    "pause",
    "stop",
    "seekBack",
    "seekForward",
  ],
};

const toAvailabilityLookup = (actionKeys = []) =>
  actionKeys.reduce((result, actionKey) => {
    result[actionKey] = true;
    return result;
  }, {});

const pickFirstAvailable = (availability, actionKeys) =>
  (actionKeys || []).find((key) => availability && availability[key]);

export const resolveServerAction = (commandKey, availability = {}) => {
  switch (commandKey) {
    case "power":
      return pickFirstAvailable(availability, ["powerOff", "powerOn"]) || "powerOff";
    case "play_pause":
      return pickFirstAvailable(availability, ["play", "pause"]) || "play";
    case "rew":
      return "seekBack";
    case "ff":
      return "seekForward";
    case "vol_up":
      return "volumeUp";
    case "vol_down":
      return "volumeDown";
    case "nav_up":
      return "up";
    case "nav_down":
      return "down";
    case "nav_left":
      return "left";
    case "nav_right":
      return "right";
    case "ok":
      return "enter";
    case "chan_up":
      return "channelUp";
    case "chan_down":
      return "channelDown";
    case "last":
      return "channelNext";
    case "input":
      return "inputSource";
    case "settings":
      return "menu";
    case "num_0":
      return "digit0";
    case "num_1":
      return "digit1";
    case "num_2":
      return "digit2";
    case "num_3":
      return "digit3";
    case "num_4":
      return "digit4";
    case "num_5":
      return "digit5";
    case "num_6":
      return "digit6";
    case "num_7":
      return "digit7";
    case "num_8":
      return "digit8";
    case "num_9":
      return "digit9";
    default:
      return commandKey;
  }
};

export const buildAvailableCommands = (availableByAction = {}) => {
  const result = {};
  Object.entries(UI_TO_ACTION_MAP).forEach(([commandKey, actionKeys]) => {
    result[commandKey] = actionKeys.some((key) => availableByAction[key]);
  });
  return result;
};

export const getDefaultAvailabilityForMethod = (method) => {
  if (method === "accessibility") {
    return getDefaultAvailabilityForMethod("app");
  }
  return toAvailabilityLookup(METHOD_ACTION_KEYS[method] || []);
};

export const getVisibleCommandsForMethod = (method, availableByAction = null) => {
  if (method === 'adb_remote') {
    return Object.fromEntries(Object.keys(UI_TO_ACTION_MAP).map((key) => [key, Boolean(ADB_REMOTE_ACTION_MAP[key])]));
  }

  if (method === "webos") {
    return Object.keys(WEBOS_ACTION_MAP).reduce((result, commandKey) => {
      result[commandKey] = true;
      return result;
    }, {});
  }

  if (method === "android_tv_remote") {
    return Object.keys(ANDROID_TV_REMOTE_ACTION_MAP).reduce((result, commandKey) => {
      result[commandKey] = true;
      return result;
    }, {});
  }

  const availability =
    availableByAction && Object.keys(availableByAction).length > 0
      ? availableByAction
      : getDefaultAvailabilityForMethod(method);

  return buildAvailableCommands(availability);
};
